import { Pagination as AntPagination, Input, message } from "antd";
import "./style.scss";
import {
  PaginationEllipsis,
  PaginationNext,
  PaginationPrev,
} from "assets/icons";
import { useContext, useEffect, useState } from "react";
import { ExploreContext } from "context/ExploreContext";

const Pagination = ({
  total = 10,
  onChange = () => {},
  currentPageNo = 1,
  pageSize = 8,
  removeQuickJumber,
}) => {
  const { tabActive } = useContext(ExploreContext);
  const totalPages = Math.ceil(total / pageSize);
  const [inputValue, setInputValue] = useState(currentPageNo);

  useEffect(() => {
    setInputValue(1);
  }, [tabActive]);

  const customItemRender = (page, type, originalElement) => {
    if (type === "prev") return <PaginationPrev />;
    if (type === "next") return <PaginationNext />;
    if (type === "jump-prev" || type === "jump-next")
      return <PaginationEllipsis />;
    return originalElement;
  };

  const handlePageChange = (page) => {
    setInputValue(page);
    onChange(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleInputKeyDown = (e) => {
    if (e.key === "Enter") {
      const val = Number(inputValue);
      if (val >= 1 && val <= totalPages) {
        handlePageChange(val);
      } else {
        // Auto-correct the value or show a warning
        if (val < 1) {
          message.warning("Minimum page is 1");
          setInputValue(1);
          handlePageChange(1);
        } else if (val > totalPages) {
          message.warning(`Maximum page is ${totalPages}`);
          setInputValue(totalPages);
          handlePageChange(totalPages);
        }
      }
    }
  };

  const customQuickJumper = (
    <div className="flex items-center gap-3 jumping-container">
      <span>Page</span>
      <Input
        type="number"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleInputKeyDown}
      />
      <span>of {totalPages}</span>
    </div>
  );

  return (
    <div
      className={`pagination-container ${removeQuickJumber && "justify-center"}`}
    >
      {/* removed custom quick jumber for search component in mobile responsive */}
      {!removeQuickJumber && customQuickJumper}
      <AntPagination
        current={currentPageNo}
        total={total}
        pageSize={pageSize}
        itemRender={customItemRender}
        onChange={handlePageChange}
        showLessItems
        showSizeChanger={false}
      />
    </div>
  );
};

export default Pagination;
